import { baseApi } from './baseApi';

export const dataRecordApi = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (build) => ({
        getDataRecordVersion: build.query<
            { presigned_download_url: string; size: number },
            { resourceVersionUuid: string }
        >({
            query: (args) => ({
                url: `/lfs/versions/${args.resourceVersionUuid}/`,
            }),
        }),
    }),
});

export const { useGetDataRecordVersionQuery } = dataRecordApi;
